const $ = jQuery.noConflict()

var self = module.exports = {
  init: function(trigger) {
    self.events.click(trigger)
  },

  events: {
    click: function(trigger) {
      $(document).on('click', trigger, function(event) {
        self.service.class(this)
      }),

      $(document).on('click', '.post-share-btn', function(event) {
        $('.property-header__share-warp').addClass('show');
        $("html, body").animate({ scrollTop: 0 }, "slow");
      }),
      $(document).on('click', '.property-header__share-warp__close', function(event) {
        $('.property-header__share-warp').removeClass('show');
      })
    }
  },

  service: {
    class: function(target) {
      $(target).toggleClass('active').blur();
    },

    copy: function(text) {
      var temp = $('<input>');
      $('body').append(temp);
      temp.val(text).select();
      document.execCommand('copy');
      temp.remove();
    }
  }
}
